<script setup>
import { computed } from 'vue'
import { Battery50Icon, BellAlertIcon, CpuChipIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../../i18n.js'

const { locale, t } = useI18n()
const props = defineProps({
  snapshot: { type: Object, default: null },
  summary: { type: Object, default: null },
  failed: Boolean,
  compact: Boolean,
})
const status = computed(() => props.snapshot ?? {})
const fresh = computed(
  () =>
    !props.failed &&
    props.summary?.connectionFreshness === 'FRESH' &&
    props.summary?.statusFreshness === 'FRESH' &&
    props.snapshot?.freshness === 'FRESH',
)
const cpu = computed(() =>
  Number.isFinite(status.value.cpuTemperatureCelsius) ? `${status.value.cpuTemperatureCelsius} °C` : '—',
)
const battery = computed(() => {
  const value = status.value.batteryVoltage
  return Number.isFinite(value)
    ? `${new Intl.NumberFormat(locale.value, { maximumFractionDigits: 2 }).format(value)} ${t('pts2UiVolts')}`
    : '—'
})
// Missing diagnostics is unknown, never a synthetic zero.
const alerts = computed(() => (Number.isInteger(status.value.activeAlertCount) && status.value.activeAlertCount >= 0 ? status.value.activeAlertCount : null))
</script>
<template>
  <div class="pc-diagnostics" :class="{ compact, historical: !fresh, attention: fresh && alerts > 0 }">
    <div class="pc-diagnostic-values">
      <span
        ><CpuChipIcon aria-hidden="true" />CPU <strong>{{ cpu }}</strong></span
      >
      <span v-if="!compact"
        ><Battery50Icon aria-hidden="true" />{{ t('pts2UiBattery') }} <strong>{{ battery }}</strong></span
      >
      <span
        ><BellAlertIcon aria-hidden="true" />{{ t('pts2UiAlerts') }} <strong>{{ alerts ?? '—' }}</strong></span
      >
    </div>
    <small v-if="!fresh">{{
      t(status.receivedAt ? 'pts2UiDiagnosticsHistorical' : 'pts2UiDiagnosticsMissing')
    }}</small>
  </div>
</template>
